import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SidePanelState {
  openSidePanel: boolean;
  sidePanelTitle: string;
  sidePanelContent:
    | 'ANNEX_IV'
    | 'EU_DECLARATION'
    | 'DOCUMENT_PREVIEW'
    | 'FRIA'
    | 'DPIA'
    | null;
}

const initialState: SidePanelState = {
  openSidePanel: false,
  sidePanelTitle: '',
  sidePanelContent: null,
};

export const sidePanelSlice = createSlice({
  name: 'sidePanel',
  initialState,
  reducers: {
    handleOpenSidePanel: (state, action: PayloadAction<boolean>) => {
      state.openSidePanel = action.payload;
    },
    setSidePanelTitle: (state, action: PayloadAction<string>) => {
      state.sidePanelTitle = action.payload;
    },
    setSidePanelContent: (
      state,
      action: PayloadAction<
        | 'ANNEX_IV'
        | 'EU_DECLARATION'
        | 'DOCUMENT_PREVIEW'
        | 'FRIA'
        | 'DPIA'
        | null
      >
    ) => {
      state.sidePanelContent = action.payload;
    },
  },
});

export const { handleOpenSidePanel, setSidePanelTitle, setSidePanelContent } =
  sidePanelSlice.actions;

export default sidePanelSlice.reducer;
